<template lang="html">
  <aside
    v-click-outside="{handler: close, events: ['mousedown'] }"
    class="aside"
  >
    <div
      class="aside__header"
      :class="{ 'aside__header--active': activeMenu }"
    />
    <nav
      class="aside__menu"
      aria-label="Меню"
    >
      <ul class="aside__menu-list">
        <li
          v-for="section in menu"
          :key="section.type"
          class="aside__menu-list-item"
          :class="{ 'aside__menu-list-item--active': activeMenu === section.type }"
        >
          <div
            class="aside__menu-list-link"
            :class="getIconClass(section.type)"
            @click="setActive(section.type)"
          >
            <div
              v-if="section.quantity"
              class="ico aside__menu-list-notification"
            >
              {{ section.quantity }}
            </div>
          </div>
          <div class="aside__submenu">
            <div class="aside__submenu-inner">
              <div
                v-if="section?.items?.length > 0"
                class="aside__submenu-title"
              >
                {{ section.title }}
              </div>
              <ul class="aside__submenu-list">
                <li
                  v-for="item in section.items"
                  :key="section.type+item.title"
                  class="aside__submenu-list-item"
                  @click="setActive(false)"
                >
                  <router-link
                    :to="{ name: item.pageName, params: { title: item.title } }"
                    class="aside__submenu-list-link"
                  >
                    {{ item.title }}
                  </router-link>
                </li>
              </ul>

              <div
                v-if="section.subSection && checkRole(section.subSection.roles)"
                :class="section?.items?.length > 0 ? 'aside__subsection' : ''"
              >
                <div class="aside__submenu-title">
                  {{ section.subSection.title }}
                </div>
                <ul class="aside__submenu-list">
                  <li
                    v-for="subSectionItem in section.subSection.items"
                    :key="section.subSection.type+subSectionItem.title"
                    class="aside__submenu-list-item"
                    @click="setActive(false)"
                  >
                    <router-link
                      v-if="checkRole(subSectionItem.roles)"
                      :to="{ name: subSectionItem.pageName, params: { title: subSectionItem.title } }"
                      class="aside__submenu-list-link"
                    >
                      {{ subSectionItem.title }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <UserInfo />
          </div>
        </li>
      </ul>

      <ul class="aside__menu-list">
        <li
          class="aside__menu-list-item"
          :class="{'aside__menu-list-item--active': activeMenu === 'help'}"
        >
          <div
            class="aside__menu-list-link aside__menu-list-link--help"
            @click="setActive('help')"
          />
          <div class="aside__submenu">
            <div class="aside__submenu-inner">
              <div class="aside__submenu-title">
                Помощь
              </div>
              <ul class="aside__submenu-list">
                <li
                  class="aside__submenu-list-item"
                  @click="setActive(false)"
                >
                  <router-link
                    :to="{ name: 'Instructions'}"
                    class="aside__submenu-list-link"
                  >
                    Инструкции по работе на площадке
                  </router-link>
                </li>
                <li
                  class="aside__submenu-list-item"
                  @click="setActive(false)"
                >
                  <router-link
                    :to="{ name: 'Contacts'}"
                    class="aside__submenu-list-link"
                  >
                    Контакты технической поддержки
                  </router-link>
                </li>
                <li
                  v-if="checkRole(['supplier'])"
                  class="aside__submenu-list-item"
                  style="cursor: pointer"
                  @click="downloadMaterialGuide"
                >
                  <span
                    class="aside__submenu-list-link"
                  >
                    Справочник наименований материалов
                  </span>
                </li>
              </ul>
            </div>
            <UserInfo />
          </div>
        </li>
        <!-- li class="aside__menu-list-item">
          <div class="aside__menu-list-link aside__menu-list-link--message"
               @click="setActive(false)"></div>
        </li>
        <li class="aside__menu-list-item">
          <div class="aside__menu-list-link aside__menu-list-link--call"
               @click="setActive(false)"></div>
        </li -->
      </ul>

      <ul class="aside__menu-list">
        <li
          class="aside__menu-list-item"
          :class="{'aside__menu-list-item--active': activeMenu === 'profile'}"
        >
          <div
            class="aside__menu-list-link aside__menu-list-link--profile"
            @click="setActive('profile')"
          />
          <div class="aside__submenu">
            <div class="aside__submenu-inner">
              <div class="aside__submenu-title">
                Профиль
              </div>
              <ul class="aside__submenu-list">
                <li
                  class="aside__submenu-list-item"
                  @click="setActive(false)"
                >
                  <router-link
                    :to="{ name: 'UserSettings'}"
                    class="aside__submenu-list-link"
                  >
                    Личные сведения
                  </router-link>
                </li>
                <li
                  class="aside__submenu-list-item"
                  @click="setActive(false)"
                >
                  <router-link
                    :to="{ name: 'OrganizationSettings'}"
                    class="aside__submenu-list-link"
                  >
                    Сведения об организации
                  </router-link>
                </li>
              </ul>
            </div>
            <UserInfo />
          </div>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
import { defineComponent } from 'vue';
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import UserInfo from '@/components/elements/UserInfo.vue';
import { intersection } from 'lodash';
import api from '@/api';
// import tr from 'air-datepicker/locale/tr';
// roles: ['customer', 'supplier', 'contractor', 'administrator'],

export default defineComponent({
  name: 'RightMenu',
  components: {
    UserInfo,
  },
  data() {
    return {
      activeMenu: false,
    };
  },
  computed: {
    ...mapState('notifications', ['quantity']),
    ...mapGetters({
      roleList: 'user/getRoleList',
    }),
    fullMenu() {
      return [
        {
          title: 'Администрирование',
          type: 'admin',
          roles: ['administrator'],
          items: [
            {
              title: 'Партнеры',
              pageName: 'PartnerOrganizations',
            },
            {
              title: 'Заказчики',
              pageName: 'CustomerOrganizations',
            },
            {
              title: 'Объекты',
              pageName: 'Objects',
            },
            {
              title: 'Ген. подрядчики',
              pageName: 'GeneralContractors',
            },
            {
              title: 'Планируемые лоты',
              pageName: 'PlannedLots',
            },
            {
              title: 'Отчеты',
              pageName: 'Reports',
            },
            {
              title: 'Справочник наименований материалов',
              pageName: 'MaterialDictionary',
            },
          ],
        },
        {
          title: 'Все закупки',
          type: 'home',
          roles: ['supplier', 'customer', 'administrator', 'gencontractor', 'contractor'],
          items: [
            /* {
              title: 'Создать новую',
              pageName: 'PageUnderConstruction',
              roles: ['customer'],
            }, */
            {
              title: 'Актуальные закупки',
              pageName: 'ActualPurchases',
              roles: ['supplier', 'customer', 'administrator'],
            },
            {
              title: 'Планируемые закупки',
              pageName: 'PlannedPurchases',
              roles: ['supplier', 'customer'],
            },
            {
              title: 'Избранные закупки',
              pageName: 'FavoritePurchases',
              roles: ['supplier', 'customer'],
            },
            {
              title: 'С моим учётом',
              pageName: 'MyPurchases',
              roles: ['supplier'],
            },
            {
              title: 'Запросы на разъяснение',
              pageName: 'ClarificationsList',
              roles: ['supplier', 'customer'],
            },
            {
              title: 'Протоколы',
              pageName: 'ProtocolList',
              roles: ['supplier'],
            },
            {
              title: 'Архив',
              pageName: 'ArchivePurchases',
              roles: ['supplier', 'customer', 'administrator'],
            },
            /* {
              title: 'Лимиты',
              pageName: 'PageUnderConstruction',
              roles: ['customer'],
            }, */
          ],
          subSection: {
            title: 'Конкурсы на подряд',
            type: 'home',
            roles: ['customer', 'gencontractor', 'contractor'],
            items: [
              {
                title: 'Создать конкурс на подряд',
                pageName: 'ContractWorkCreate',
                roles: ['customer'],
              },
              {
                title: 'Конкурсы на подряд',
                pageName: 'ContractWorksList',
                roles: ['customer', 'contractor', 'gencontractor'],
              },
              {
                title: 'Архив',
                pageName: 'ContractWorksListArchive',
                roles: ['customer', 'contractor'],
              },
            ],
          },
        },
        {
          title: 'Поставки',
          type: 'supplies',
          roles: ['supplier', 'customer', 'contractor'],
          items: [
            {
              title: 'Создать заявку',
              pageName: 'SupplyRequestCreate',
              roles: ['contractor'],
            },
            {
              title: 'Заявки на поставку',
              pageName: 'SupplyRequestList',
              roles: ['customer', 'contractor'],
            },
            {
              title: 'Задания на поставку',
              pageName: 'SupplyTaskList',
              roles: ['supplier', 'customer'],
            },
            /* {
              title: 'Отмененные',
              pageName: 'PageUnderConstruction',
            },
            {
              title: 'Архив',
              pageName: 'PageUnderConstruction',
            }, */
          ],
        },
        {
          title: 'Договоры',
          type: 'contracts',
          roles: ['customer', 'supplier', 'contractor'],
          items: [
            /* {
              title: 'Создать',
              pageName: 'PageUnderConstruction',
              roles: ['customer'],
            }, */
            {
              title: 'Список договоров',
              pageName: 'СontractList',
            },
            {
              title: 'Документы',
              pageName: 'Documents',
            },
            /* {
              title: 'Заключение',
              pageName: 'PageUnderConstruction',
            }, */
          ],
        },
        {
          title: 'Настройки',
          type: 'settings',
          roles: ['customer', 'supplier', 'contractor'],
          items: [
            {
              title: 'Личные сведения',
              pageName: 'UserSettings',
            },
            {
              title: 'Сведения об организации',
              pageName: 'OrganizationSettings',
            },
            {
              title: 'Изменить адрес электронной почты',
              pageName: 'EmailChange',
            },
            {
              title: 'Изменить пароль',
              pageName: 'PasswordChange',
            },
          ],
        },
        {
          title: 'Уведомления',
          type: 'notifications',
          quantity: this.quantity,
          items: [
            /* {
              title: 'Создать',
              pageName: 'PageUnderConstruction',
              roles: ['customer'],
            }, */
            {
              title: 'Входящие',
              pageName: 'NotificationList',
            },
            /* {
              title: 'Исходящие',
              pageName: 'PageUnderConstruction',
              roles: ['customer'],
            }, */
          ],
        },
      ];
    },
    menu() {
      return this.fullMenu
        .filter((element) => this.checkRole(element.roles))
        .map((element) => ({
          ...element,
          items: this.getSubMenu(element.items),
        }));
    },
  },
  mounted() {
    this.actionFetchNotificationQuantity();
  },
  methods: {
    ...mapMutations('appService', ['setFilterState']),
    ...mapActions({
      actionFetchNotificationQuantity: 'notifications/fetchQuantity',
    }),
    close() {
      this.activeMenu = false;
    },
    setActive(key) {
      if (this.activeMenu === key) {
        this.activeMenu = false;
      } else {
        this.activeMenu = key;
      }
      this.setFilterState(false);
    },
    getIconClass(sectionType) {
      return `aside__menu-list-link--${sectionType}`;
    },
    getSubMenu(menuItems) {
      return menuItems.filter((element) => this.checkRole(element.roles));
    },
    checkRole(roles) {
      if (!roles) {
        return true;
      }

      return !!intersection(roles, this.roleList).length;
    },
    async downloadMaterialGuide() {
      try {
        const { data } = await api.supplyRequest.getMaterialsGuideFile();
        window.open(data.result, '_blank');
      } catch (e) {
        console.error(e);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.aside__menu-list-notification {
  position: absolute;
  display: block;
  background: #f5f6f8;
  border-radius: 100%;
  padding: 0 0.4em;
  font-size: 0.7em;
  right: 0.3em;
  top: -0.2em;
  font-family: Open Sans, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  min-width: 22px;
  z-index: 3;
  text-align: center;
}
</style>
